import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from 'helper/className';
import Avatar from '../Avatar/Avatar';
import Dropdown from '../Dropdown/Dropdown';

const RenderTitle = (account) => (
  <Avatar src={account.portraitUrl} size={20} canEdit={false} circle />
);

const UserInfoDropdown = ({ className, children, account }) => (
  <Dropdown titleRenderer={() => RenderTitle(account)} className={classNames(className, UserInfoDropdown.className)}>
    {children}
  </Dropdown>
);

UserInfoDropdown.className = 'user-info-dropdown';
UserInfoDropdown.getClassName = getClassNameGenerator(UserInfoDropdown.className);

UserInfoDropdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  account: PropTypes.object
};

UserInfoDropdown.defaultProps = {
  account: {}
};

export default UserInfoDropdown;
